import React from "react";
import classNames from "classnames";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	block: {
		width: "585px",
		margin: "0 0 40px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		"& svg": {
			margin: "0 0 15px",
		},
		"& h2": {
			margin: "0 0 5px",
			fontSize: "24px",
			lineHeight: "24px",
			fontFamily: theme.fonts.medium,
			color: theme.palette.colors.darkSlateBlue2,
			"& > a": {
				textDecoration: "underline",
				color: theme.palette.colors.violet,
			},
		},
		"& span": {
			margin: 0,
			fontSize: "16px",
			lineHeight: "16px",
			fontFamily: theme.fonts.light,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
			"& > a": {
				textDecoration: "underline",
				color: theme.palette.colors.violet,
			},
		},
		"& ul": {
			marginBlock: 0,
			paddingInline: 0,
			display: "grid",
			gridTemplateColumns: "repeat(2, 2fr)",
		},
		"& li": {
			fontSize: "16px",
			lineHeight: "16px",
			fontFamily: theme.fonts.light,
			color: theme.palette.colors.darkSlateBlue,
			listStylePosition: "inside",
		},
	},
	marginRight: {
		marginRight: "10px",
	},
	background: {
		padding: "30px 160px",
		border: "1px solid #DCE0E9",
		borderRadius: "20px",
		background: theme.palette.colors.white,
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		block: {
			width: "465px",
		},
		background: {
			padding: "30px 90px",
		},
	},
	[`@media (max-width: ${theme.media.md})`]: {
		block: {
			width: "100%",
			"& svg": {
				margin: "0 0 5px",
			},
			"& h2": {
				fontSize: "18px",
				lineHeight: "20px",
			},
			"& span": {
				fontSize: "14px",
			},
			"& li": {
				fontSize: "14px",
			},
		},
		marginRight: {
			marginRight: 0,
		},
		background: {
			padding: "20px 40px",
		},
	},
}));

const InfoBlock = (props) => {
	const classes = useStyles();
	const { svg, header, text, background, marginRight } = props;

	return (
		<div
			className={classNames(classes.block, {
				[classes.background]: background,
				[classes.marginRight]: marginRight,
			})}
		>
			{svg}
			<h2>{header}</h2>
			{text}
		</div>
	);
};

export default InfoBlock;
